<template>
  <div style="padding: 20px">
    <v-card text style="min-height: 100%; width: 100%; height: 100%">
      <v-card-actions>
        <h2>Mailchimp Email Campaign Creation</h2>
        <v-spacer></v-spacer>
        <div>
          <v-btn color="blue darken-1" text @click.native="cancel"
            >Cancel
            <v-icon style="padding-left: 20px" left color="red"
              >mdi-cancel</v-icon
            ></v-btn
          >
          <v-btn color="blue darken-1" text @click.native="save"
            >Create
            <v-icon style="padding-left: 20px" left color="green"
              >mdi-content-save</v-icon
            ></v-btn
          >
          <v-btn color="blue darken-1" text @click.native="test"
            >Send Test
            <v-icon style="padding-left: 20px" left color="yellow"
              >mdi-bug-check</v-icon
            ></v-btn
          >
        </div>
      </v-card-actions>
      <v-card-text>
        <v-row class="mx-0">
          <div class="text-subtitle-1">
            This page allows the definition and scheduling of email marketing
            campaigns using Mailchimp. All campaigns must be based on a template
            that already exists in the Mailchimp account. Creation of email
            templates is currently no supported in Cortex.
          </div>
        </v-row>
      </v-card-text>
      <v-card-title> Recipient Count: {{ count }} </v-card-title>
      <v-divider class="mx-4"></v-divider>
      <v-card-title> General Settings</v-card-title>
      <v-card-text>
        <v-row class="mx-0">
          <div class="text-subtitle-1">
            General settings for an email marketing campaign.
          </div>
          <v-container fluid>
            <v-row>
              <v-col cols="6">
                <v-text-field label="Campaign Name"></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field label="Email Subject"></v-text-field>
              </v-col>
              <v-col cols="6">
                 <v-select
                  :items=templateList
                  item-text="name"
                  attach
                  chips
                  label="Template"
                  v-model="targetTemplate"
                >
                 </v-select>
              </v-col>
              <v-col cols="6">
                
                  <VueCtkDateTimePicker 
                  :error-messages="'Error Detected'" 
                  v-model="sendTime" 
                  no-value-to-custom-elem
                  output-format="llll"
                  :dark="dark"
                  minute-interval="5"
                >
                <v-text-field 
                  label="Send Date & Time" 
                  :value="sendTime" 
                  :error-messages="''"
                  clearable
                ></v-text-field>
                  
                </VueCtkDateTimePicker>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
      </v-card-text>
      <v-divider class="mx-4"></v-divider>
      <v-card-title>Recipient Selection </v-card-title>
      <v-card-text>
        <v-row class="mx-0">
          <div class="text-subtitle-1">Select who gets this campaign.</div>
          <v-container fluid>
            <v-row>
              <v-col cols="6">
                <v-select
                  :items=stateList
                  attach
                  chips
                  label="Target States"
                  item-text="name"
                  item-value="id"
                  multiple
                  v-model="targetStates"
                >
                </v-select>
              </v-col>
              <v-col cols="6">
                <v-select
                  :items=campaignList
                  item-text="name"
                  attach
                  chips
                  label="Received Campaigns"
                  multiple
                  v-model="targetCampaigns"
                  item-value="id"
                >
                </v-select>
              </v-col>
              <v-col cols="6">
                <v-switch class="v-input--reverse" v-model="open">
                  <template #label>Opened Campaign Email</template>
                </v-switch>
              </v-col>
              <v-col cols="6">
                <v-switch class="v-input--reverse" v-model="click">
                  <template #label>Clicked Link</template>
                </v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
      </v-card-text>
      <v-divider class="mx-4"></v-divider>
    </v-card>
  </div>
</template>
<script>
import helper from "./helper";
export default {
  data: () => ({
    count: null,
    stateList: [],
    targetStates: [],
    campaignList: [{"id":null, "name":"None"}, {"id": "any", "name":"Any"}],
    templateList: [],
    targetTemplate: null,
    targetCampaigns: [],
    open: false,
    click: false,
    sendTime: null,
    dark: true
  }),
  watch: {
    targetStates: async function(val){
        console.log(`State Selection Changed: ${val}` )
        await this.getRecipientCount(false)
    },
    targetCampaigns: async function(val){
        console.log(`Campaign Selection Changed: ${val}`)
        await this.getRecipientCount(false)
    },
    click: async function(val){
        console.log(`Click Selection Changed`)
        await this.getRecipientCount(false)
    },
    open: async function(val){
        console.log(`Open Selection Changed`)
        await this.getRecipientCount(false)
    }
  },
  methods: {
      async getRecipientCount(initialCount){
          if(initialCount) this.count = 0
          else {
              this.count = await helper.getCount(this.targetStates, this.targetCampaigns, this.open, this.click)
          }
      }
  },
  async beforeMount(){
      console.log("In the before mount function")
      let templateResults = await helper.getTemplateList()
      let stateResults = await helper.getStateList()
      let campaignResults = await helper.getCampaignList()
      for(const entry of templateResults){
         this.templateList.push({"id": entry["_id"], "name": entry["name"]})
      }
      for(const entry of stateResults){
          this.stateList.push({"id": entry["_id"], "name": `${entry["name"]} - ${entry["code"]}`})
      }
      for(const entry of campaignResults){
          this.campaignList.push({"id": entry["chimpid"], "name": entry["name"]})
      }
      await this.getRecipientCount(true)
  }
};
</script>
<style>
.v-input--reverse .v-input__slot {
  flex-direction: row-reverse;
  justify-content: flex-end;
}
</style>
